/**
 * Shared field constants for the Node Details Panel.
 *
 * Anything cross-cutting between multiple field wrappers (`TextAreaField`,
 * `AgentInstructionField`, etc.) lives here so drift is impossible.
 */

/**
 * Default max-height cap for multiline text editors rendered in the drawer.
 *
 * Design research (three sources, model-diverse review):
 *   - **Material 3 (Google)** — Vertex AI Studio prompt field: `clamp(120px, 20vh, 200px)`
 *   - **Figma right-panel** — description/annotation fields: `clamp(160px, 28dvh, 240px)`
 *   - **Linear settings composers** — `min(240px, 28vh)`
 *
 * Consensus (2/3 designers): **240px ceiling** + **28vh** scale → synthesis
 * is `clamp(160px, 28vh, 240px)`:
 *   - `160px` floor  = ~7 lines at 20px line-height. Enough context to read
 *                      a multi-sentence system prompt without cramping.
 *   - `28vh`         = scales with viewport. 900px viewport ≈ 252px (clamped
 *                      to 240px). 700px short-laptop ≈ 196px. 1200px monitor
 *                      still hits the ceiling — prevents 4K walls.
 *   - `240px` ceiling = ~11 lines. Matches Fluent Combobox multi-line convention
 *                      and Linear's stacked-settings composers.
 *
 * `vh` (not `dvh`) for Safari <15.4 compatibility. On tall mobile with URL
 * bar this loses a few px — acceptable trade-off vs cross-browser breakage.
 *
 * Beyond this cap, the editor's internal scrollbar takes over and an
 * expand button opens the full content in `ExpandableEditorDialog`.
 */
export const MULTILINE_TEXT_MAX_HEIGHT = 'clamp(160px, 28vh, 240px)';
